import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const EventDetails = (props) => {
    const event = props.data.find(({_id}) => _id === props.eventId)
    return (
        <div>
        <Modal isOpen={props.modal} toggle={props.toggleEventDetails}>
            <ModalHeader toggle={props.toggleEventDetails}><b>Event Details</b></ModalHeader>
            <ModalBody>
                <h6><b>Event Description</b></h6>
                <p style={{whiteSpace: "pre-wrap"}}>{event?event.description:<i>Select Event Date</i>}</p> 
                <h6><b>Difficulty Level</b></h6>       
                <p>{event?event.difficulty:<i>Select Event Date</i>}</p>
                {event&&event.location?<a href={event.location} target='blank'>Location</a>:null}
            </ModalBody>
        </Modal>
        </div>
    );
}

export default EventDetails;